import { render } from "./Achievements.vue?vue&type=template&id=9365be20"
import script from "./Achievements.vue?vue&type=script&lang=js"
export * from "./Achievements.vue?vue&type=script&lang=js"
script.render = render

export default script